export default __webpack_public_path__ + "static/media/entrance.4362b935.svg";